import { create } from "zustand";
import { ChatTheme, Theme } from "./types";
import { Themes } from "../../types";
import { getCookie, setCookie } from "../../utils";

const CHAT_THEMES: Array<ChatTheme> = [
  {
    primary: "linear-gradient(to top right, #2A8BF2, #7CB8F7)",
    secondary: "white",
    textOnPrimary: "white",
    textOnSecondary: "#707C97",
  },
  {
    primary: "#03346E",
    secondary: "white",
    textOnPrimary: "white",
    textOnSecondary: "#707C97",
  },
  {
    primary: "#677D6A",
    secondary: "white",
    textOnPrimary: "white",
    textOnSecondary: "#707C97",
  },
];

const THEMES: Array<Theme> = [
  {
    background: "#212121",
    icon: "#6f6f76",
    iconLowOpacity: "rgba(111, 111, 118, 0.1)",
    overlay: "#2c2c2c",
    primary: "#F9A825",
    secondary: "#1D90F5",
    alert: "#FF3A3D",
    textOnBg: "#ffffff",
    textOnOverlay: "#ffffff",
    textOnprimary: "#ffffff",
    textonSecondary: "#ffffff",
    textOnAlert: "#ffffff",
    chat: CHAT_THEMES[0],
  },
  {
    background: "#F5F5FC",
    icon: "#6F6F76",
    iconLowOpacity: "rgba(111, 111, 118, 0.1)",
    overlay: "#ffffff",
    primary: "#F9A825",
    secondary: "#1D90F5",
    alert: "#FF3A3D",
    textOnBg: "#2C2C2C",
    textOnOverlay: "#2C2C2C",
    textOnprimary: "#ffffff",
    textonSecondary: "#ffffff",
    textOnAlert: "#ffffff",
    chat: CHAT_THEMES[0],
  },
  {
    background: "#03071e",
    icon: "#6f6f76",
    iconLowOpacity: "rgba(111, 111, 118, 0.1)",
    overlay: "#370617",
    primary: "#F9A825",
    secondary: "#1D90F5",
    alert: "#FF3A3D",
    textOnBg: "#ffffff",
    textOnOverlay: "#ffffff",
    textOnprimary: "#ffffff",
    textonSecondary: "#ffffff",
    textOnAlert: "#ffffff",
    chat: CHAT_THEMES[0],
  },
  {
    background: "#522258",
    icon: "white",
    iconLowOpacity: "rgba(255, 255, 255, 0.1)",
    overlay: "#8C3061",
    primary: "#C63C51",
    secondary: "#D95F59",
    alert: "#FF3A3D",
    textOnBg: "#ffffff",
    textOnOverlay: "#ffffff",
    textOnprimary: "#ffffff",
    textonSecondary: "#ffffff",
    textOnAlert: "#ffffff",
    chat: CHAT_THEMES[1],
  },
  {
    background: "#1A3636",
    icon: "white",
    iconLowOpacity: "rgba(255, 255, 255, 0.1)",
    overlay: "#40534C",
    primary: "#D6BD98",
    secondary: "#677D6A",
    alert: "#FF3A3D",
    textOnBg: "#ffffff",
    textOnOverlay: "#ffffff",
    textOnprimary: "black",
    textonSecondary: "#ffffff",
    textOnAlert: "#ffffff",
    chat: CHAT_THEMES[2],
  },
];

const themeCookie: number = Number(getCookie("theme"));
const DEFAULT_THEME = Themes.Dark;
const INITIAL_THEME =
  isNaN(themeCookie) || themeCookie < 0 || themeCookie > THEMES.length
    ? DEFAULT_THEME
    : (themeCookie as Themes);

interface State {
  activeTheme: Themes;
  theme: Theme;
}

interface Action {
  setTheme: (themeName: Themes) => void;
  swapTheme: () => void;
}

const useThemeStore = create<State & Action>((set, get) => ({
  activeTheme: INITIAL_THEME,
  theme: THEMES[INITIAL_THEME],
  setTheme: (theme: Themes): void => {
    setCookie("theme", String(theme));
    set({ theme: THEMES[theme], activeTheme: theme });
  },
  swapTheme: (): void => {
    // if (get().activeTheme === Themes.Dark) {
    //   get().setTheme(Themes.Light);
    // } else {
    //   get().setTheme(Themes.Dark);
    // }
    let active = Number(get().activeTheme);
    if (active < THEMES.length - 1 && active > -1) get().setTheme(active + 1);
    else get().setTheme(0);
  },
}));

export default useThemeStore;

// TODO:
// we can save theme in cookies;
